import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, UseFormSetError } from "react-hook-form";
import { ModalEditorProvider } from "../../context/GrapejsModalContext";
import { IPopup } from "../../types/interface";
import { popupValidation } from "../../utils/validationSchema";
import GrapesJSEditor from "../GrapesjsEditor/ModalEditor/GrapesJSEditor";
interface Props {
  handleUpdate: (
    data: IPopup,
    setError: UseFormSetError<IPopup>
  ) => Promise<void>;
  isUpdatingPopup: boolean;
  popupInfo: IPopup;
}

export default function EditPage({
  handleUpdate,
  isUpdatingPopup,
  popupInfo,
}: Props) {
  const updatePopupMethods = useForm<IPopup>({
    defaultValues: { ...popupInfo },
    resolver: yupResolver(popupValidation),
  });

  return (
    // <FormLayout
    //   isLoading={isUpdatingPopup}
    //   handleSubmit={updatePopupMethods.handleSubmit}
    //   handleFormSubmit={handleUpdate}
    //   buttonLabel="Update"
    //   disabled={isUpdatingPopup}
    //   setError={updatePopupMethods.setError}
    // >
    //   <FormProvider {...updatePopupMethods}>
    //     <PageForm />
    //   </FormProvider>
    // </FormLayout>

    <ModalEditorProvider>
      <GrapesJSEditor />
    </ModalEditorProvider>
  );
}
